import { alertError } from '@src/lib/alert';

export async function fetchWithHandling<T>(
  resource: () => Promise<T>,
  setFetchingFlag?: (isFetching: boolean) => void,
  setResult?: (result: T) => void,
  errorMsg = 'Something went wrong',
): Promise<T | undefined> {
  if (setFetchingFlag !== undefined) {
    setFetchingFlag(true);
  }
  try {
    const response = await resource();
    if (setResult !== undefined) {
      setResult(response);
    }
    return response;
  } catch (err) {
    console.error(err);
    alertError(errorMsg);
  } finally {
    if (setFetchingFlag !== undefined) {
      setFetchingFlag(false);
    }
  }
  return undefined;
}
